import { render, staticRenderFns } from "./bxsBg.vue?vue&type=template&id=36e76030&scoped=true&functional=true"
import script from "./bxsBg.vue?vue&type=script&lang=js"
export * from "./bxsBg.vue?vue&type=script&lang=js"
import style0 from "./bxsBg.vue?vue&type=style&index=0&id=36e76030&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "36e76030",
  null
  
)

export default component.exports